import { databases } from "@/lib/appwrite";

export const sendFeedback = async (
  userId: string,
  title: string,
  description: string,
) => {

  const response = await databases.createDocument(
    import.meta.env.VITE_APPWRITE_DATABASE_ID,
    import.meta.env.VITE_FEEDBACK_COLLECTION_ID,
    "unique()",
    {
      userId,
      title,
      description,
      isRead: false,
    }
  );

  return response;
};


